<template>
  <form class="recover">
    <inputText
      placeholder="Введите ссылку на репост в VK"
      :field="link"
      size="lg"
      @input="link = $event"
      type="text"
      :class="{ error: validationStatus($v.link) || errorMessage.link || errorMessage.id }"
      :error="
        (!$v.link.required && $v.link.$error
          ? 'Обязательное поле'
          : !$v.link.link && $v.link.$error
            ? 'Некорректная ссылка'
          : '') || errorMessage.link || errorMessage.id
      "
    />

    <div class="recover__footer">
      <button
        type="button"
        class="btn btn--primary w-100"
        @click="submit()"
        :class="{ loading: submitStatus == 'PENDING' }"
      >
        Добавить<img
          src="../../assets/img/spinner.svg"
          class="loader"
          alt=""
        />
      </button>
    </div>
  </form>
</template>

<script>
import inputText from "@/components/form/inputText.vue";

import { required } from "vuelidate/lib/validators";
const objRE = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
const link = (value) => objRE.test(value);
export default {
  name: "RecoverForm",
  props: ["id"],

  data() {
    return {
      ready: false,
      index: 1,
      link: null,

      errorMessage: {
        link: null,
        id: null,
      },

      submitStatus: null,
    };
  },

  validations: {
    link: { required, link },
  },

  methods: {
    errorReset() {
      this.$v.$reset();

      this.errorMessage = {
        link: null,
        id: null,
      };
    },

    validationStatus: function (validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    showAuthorization() {
      this.$modal.hide("recover");
      this.$modal.show("authorization");
    },
    submit() {
      this.$v.$touch();

      if (this.$v.$pendding || this.$v.$error) return;

      if (this.submitStatus !== "PENDING") {
        this.submitStatus = "PENDING";

        this.$store
          .dispatch("AddRepost", {
            photo_id: this.id,
            repostLink: this.link,
          })
          .then((r) => {
            console.log(r);
            
            if (!r.result) {
              this.submitStatus = null;

              let fieldsError = null;

              if (r.error && r.error.photo_id) {
                [this.errorMessage.id] = r.error.photo_id;
                fieldsError = true;
              }
              if (r.error && r.error.repostLink) {
                [this.errorMessage.link] = r.error.repostLink;
                fieldsError = true;
              }

              if (r.error && !fieldsError) {
                this.$modal.hide("repost");
                this.$modal.show("common_error", {
                  title: r.error,
                });
              }
            } else {
              this.submitStatus = null;

              this.$modal.hide("repost");
              this.$modal.show("common_success", {
                title: "подтверждение репоста",
                text: "спасибо, ссылка отправлена на модерацию"
              });
              this.gtmEvent("repost_success", "do", "internal");
              this.$store.dispatch("GetCodes", { page: 1 });
            }
          })
          .catch((e) => {
            this.submitStatus = null;
          });
      }
    },
  },
  mounted() {},
  components: {
    inputText,
  },
};
</script>

<style lang="scss">
.recover {
  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: rem(35px);
    text-align: center;
  }
  .btn {
    margin-bottom: rem(15px);
  }
}
</style>
